import { Accordion, Stack } from 'react-bootstrap';

interface AccordionProps {
  eventKey: string;
  text: string;
  children: any;
  noBorder?: boolean;
  rightAction?: any;
  leftAction?: any;
  color?: string;
  className?: string;
}

const AccordionItem = ({
  eventKey,
  text,
  children,
  className = '',
  noBorder,
  rightAction,
  leftAction,
  color,
}: AccordionProps) => {
  return (
    <Accordion.Item eventKey={eventKey} className={className}>
      <Stack
        direction="horizontal"
        className={`${
          noBorder ? 'border-bottom py-1 rounded-0' : 'border mb-2 py-2 px-3'
        }`}
      >
        <Stack className="flex-grow-1" direction="horizontal" gap={3}>
          <Accordion.Button className={`text ${color} w-100`}>
            <span className="mx-3">{text}</span>
            {leftAction}
          </Accordion.Button>
        </Stack>
        <Stack direction="horizontal" gap={3} className="ms-auto">
          {rightAction}
          <Accordion.Button className="d-flex align-items-center justify-content-center" />
        </Stack>
      </Stack>
      {children && (
        <Accordion.Body className={`${!noBorder ? 'border' : 'py-1'}`}>
          {children}
        </Accordion.Body>
      )}
    </Accordion.Item>
  );
};

export default AccordionItem;
